import reactRpc from '@square/react-rpc-client';
import Cookies from 'js-cookie';
import { ConsoleLoggerFactory } from '@square/react-rpc-client/utils';
import { RpcError } from 'rpc/model/Error';
import { getEnvironment, Env } from 'typescript/utilities/environment';
import { CSRF_COOKIE, CSRF_HEADER } from 'typescript/services/utils';

const loggingEnabled = getEnvironment() !== Env.PRODUCTION;

const getAdditionalHeaders = () => {
  const additionalHeaders = new Map();
  const csrfCookieVal = Cookies.get(CSRF_COOKIE);

  if (csrfCookieVal) {
    additionalHeaders.set(CSRF_HEADER, csrfCookieVal);
  }

  return additionalHeaders;
};

const rpc = () => {
  const additionalHeaders = getAdditionalHeaders();

  return reactRpc({
    loggerFactory: new ConsoleLoggerFactory(loggingEnabled),
    errorDeserializer: RpcError.fromResponse,
    additionalHeaders,
  });
};

export default rpc;
